module.exports = __webpack_public_path__ + "static/img/19.eed86acf.png";